/**
 * Parse and format name with email in "name (email)" format
 * Splits into name displayed above email with appropriate CSS classes
 * @param nameString string in format "Name (email@example.com)"
 * @returns JSX element with name and email displayed vertically, or original string if no match
 */
export function formatNameWithEmail(nameString: string | null | undefined): JSX.Element | string {
    if (!nameString) return "";
    const match = /^([^(]+)\(([^)]+)\)$/.exec(nameString);
    if (match) {
        const [, name, email] = match;
        return (
            <div className="d-flex flex-column">
                <span className="text-body">{name.trim()}</span>
                <span className="text-body-secondary">{email.trim()}</span>
            </div>
        );
    }
    return nameString;
}